<template>
    <div class="errors">
        <div v-if="v.hasOwnProperty('numeric') && !v.numeric">{{$t('validation.numeric')}}</div>
        <div v-if="v.hasOwnProperty('isEqual10') && !v.isEqual10 && v.numeric">{{$t('validation.equal_10')}}</div>
        <div v-if="v.hasOwnProperty('required') && !v.required">{{$t('validation.required')}}</div>
        <div v-if="v.hasOwnProperty('minLength') && !v.minLength">{{$t('validation.check_min_value', { min: v.$params.minLength.min })}}</div>
        <div v-if="v.hasOwnProperty('email') && !v.email">{{$t('validation.email')}}</div>
        <div v-if="v.hasOwnProperty('sameAs') && v.required && !v.sameAs && v.checkPassword">{{$t('validation.not_equal')}}</div>

        <div v-if="v.hasOwnProperty('checkPassword') && v.required && !v.checkPassword">{{$t('validation.long_password')}}</div>
    </div>
</template>

<script>
    export default {
        props: {
            v: {
                type: Object,
                required: true,
            }
        }
    }
</script>

<style lang="sass" scoped>
.errors
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    +reg
    color: $color--red
    font-size: 10px
</style>
